<template>
  <div>
    <b-overlay :show="isBusy" rounded="sm" :spinner-small="false">
      <form id="submitPasswordForgotForm" @submit.prevent="doSubmit()">
        <h3>Recover Password</h3>
        If you are an Agent user and you have forgotten your password, enter
        your registered email address into the box below and press submit.

        <b-row>
          <b-col>
            <div class="form-group">
              <input
                id="agent-recover-password"
                type="text"
                v-model="emailReset"
                class="form-control form-control-lg"
                ref="emailFormField"
              />
            </div>
          </b-col>
        </b-row>
        <div class="bottom-section">
          <div class="paypoint-link">
            <a id="back-to-login-form" @click="backToLoginPageClickHandler()"
              >Back to Login</a
            >
          </div>
          <div class="login-button">
            <ButtonNew
              buttonId="PasswordResetButton"
              variant="search"
              type="submit"
              :isDisabled="isDisabledCallback(this.emailReset)"
              datacy="submit-forgot-password-form-button"
            >
              Send E-Mail
            </ButtonNew>
          </div>
        </div>
      </form>
    </b-overlay>
  </div>
</template>
<script>
import ButtonNew from "Components/ButtonNew";

export default {
  name: "PasswordResetForm",
  components: {
    ButtonNew,
  },
  data() {
    return {
      emailReset: "",
    };
  },
  props: {
    email: {
      type: String,
      required: false,
    },
    submitPasswordForgotFormCallback: {
      type: Function,
      required: true,
    },
    isBusy: {
      type: Boolean,
      required: true,
      default: true,
    },
    isDisabledCallback: {
      type: Function,
      required: true,
    },
    backToLoginPageClickHandler: {
      type: Function,
      required: true,
    },
  },
  mounted() {
    this.focusInput();
    this.emailReset = this.email;
  },
  methods: {
    focusInput() {
      this.$refs.emailFormField.focus();
    },
    doSubmit() {
      this.submitPasswordForgotFormCallback(this.emailReset);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "Design/paypoint-styles.scss";
.form-group {
  margin-bottom: 1rem;
  margin-top: 1rem;
}
.bottom-section {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
</style>
